import classNames from 'classnames';
import * as React from 'react';

import { LinkViewModel } from '../../Common/LinkViewModel.csharp';
import TouchSwiper from '../../ReactComponents/TouchSwiper/TouchSwiper';
import { LinkListProps } from './LinkList';
import { LinkListBackgroundVariant } from './LinkListBackgroundVariant.csharp';
import LinkListItem from './LinkListItem';

export function LinkListWithSwiper(props: LinkListProps) {
    const maxItemsAmount = 10;
    const { backgroundVariant } = props.model;
    const links = props.model.links.slice(0, maxItemsAmount);
    const firstColumn = links.filter((x, i) => i % 2 === 0);
    const secondColumn = links.filter((x, i) => i % 2 !== 0);

    const backgroundModifier = `LinkListWithSwiper--${LinkListBackgroundVariant[backgroundVariant]}`;

    const getColumn = (columnLinks: LinkViewModel[]) => {
        return columnLinks.map((link, index) => (
            <li className="LinkListWithSwiper__Item" key={index}>
                <LinkListItem model={link} />
            </li>
        ));
    };

    return (
        <div className={classNames('LinkListWithSwiper', backgroundModifier)}>
            <div className="LinkListWithSwiper__Inner">
                <ul className="LinkListWithSwiper__Items LinkListWithSwiper__Items--Desktop">{getColumn(links)}</ul>
                <div className="LinkListWithSwiper__Items LinkListWithSwiper__Items--Mobile">
                    <TouchSwiper>
                        <ul className="LinkListWithSwiper__Column">{getColumn(firstColumn)}</ul>
                        {secondColumn.length > 0 && <ul className="LinkListWithSwiper__Column">{getColumn(secondColumn)}</ul>}
                    </TouchSwiper>
                </div>
            </div>
        </div>
    );
}
